import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 1px solid #ececec;
  overflow: hidden;
  border-radius: 4px;
  margin-top: 8px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #d5deff;
  height: 112px;
  padding: 24px;
  flex: 1;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px 12px 24px 12px;
  overflow: auto;
  padding: 12px 10px 24px 12px;

  @media (max-height: 800px) {
    max-height: 200px;
  }

  @media (min-height: 900px) {
    max-height: 300px;
  }

  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px; /* Add rounded corners to the scrollbar thumb */
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LightText = styled.div`
  color: #333333;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  spacing: -0.01em;
`;

export const StrongText = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: #333333;
`;

export const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 8.5px 16px 8.5px 24px;
  border-radius: 8px;
  min-height: 40px;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  margin-top: 8px;
  min-width: 400px;
`;

export const HeaderText = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;

  display: flex;
  align-items: center;
`;

export const Cell: any = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  text-overflow: ellipsis;
`;

export const CellSmall: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 50px;
  text-overflow: ellipsis;
`;
export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 100px;
`;
export const Footer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  background: #d5deff;
  width: 100%;
  height: 54px;
  padding: 0px 16px;
  font-family: "Inter";
  font-style: normal;
  color: #333333;
  gap: 8px;

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
  }
  span {
    font-weight: 500;
    font-size: 24px;
    line-height: 40px;
    letter-spacing: -0.01em;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 70px 0 70px 0;
`;
